import React from 'react';
import classNames from 'classnames';
import { bool, string } from 'prop-types';

import { FormattedMessage } from '../../../util/reactIntl';
import onbuoyLogo from '../../../assets/onbuoy-logo-icon.png';
import css from './SearchLoadingIndicator.module.css';

const SearchLoadingIndicator = props => {
  const { compact = false, messageId = 'MainPanelHeader.loadingResults' } = props;

  return (
    <div
      className={classNames(css.root, { [css.compact]: compact })}
      role="status"
      aria-live="polite"
    >
      <div className={css.buoyAnim} aria-hidden="true">
        <img src={onbuoyLogo} alt="" width="50" height="50" className={css.buoyImage} />
      </div>
      <div className={css.water} aria-hidden="true">
        <svg
          className={css.waveSlow}
          width="240"
          height="43"
          viewBox="0 0 240 43"
          preserveAspectRatio="none"
        >
          <path
            d="M0 4.5 q 15 -3 30 0 q 15 3 30 0 q 15 -3 30 0 q 15 3 30 0 q 15 -3 30 0 q 15 3 30 0 q 15 -3 30 0 q 15 3 30 0 q 15 -3 30 0 q 15 3 30 0 L 240 43 L 0 43 Z"
            fill="rgba(52,165,230,0.34)"
          />
        </svg>
        <svg
          className={css.waveFast}
          width="240"
          height="43"
          viewBox="0 0 240 43"
          preserveAspectRatio="none"
        >
          <path
            d="M0 7 q 15 -3 30 0 q 15 3 30 0 q 15 -3 30 0 q 15 3 30 0 q 15 -3 30 0 q 15 3 30 0 q 15 -3 30 0 q 15 3 30 0 q 15 -3 30 0 q 15 3 30 0 L 240 43 L 0 43 Z"
            fill="rgba(52,165,230,0.55)"
          />
          <path
            d="M0 7 q 15 -3 30 0 q 15 3 30 0 q 15 -3 30 0 q 15 3 30 0 q 15 -3 30 0 q 15 3 30 0 q 15 -3 30 0 q 15 3 30 0 q 15 -3 30 0 q 15 3 30 0"
            fill="none"
            stroke="rgba(52,165,230,0.85)"
            strokeWidth="1.4"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <span className={css.assistiveText}>
        <FormattedMessage id={messageId} />
      </span>
    </div>
  );
};

SearchLoadingIndicator.propTypes = {
  compact: bool,
  messageId: string,
};

export default SearchLoadingIndicator;
